<ion-card
  class="dutyfree-card ion-margin-horizontal ion-margin-bottom mart0"
  *ngFor="let item of retailerList"
>
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col size="5">
        <img [src]="item?.img || imagePlaceholder" />
      </ion-col>

      <ion-col size="7" class="card-info">
        <ion-card-header
          class="ion-no-padding fs-3 mart6 ion-padding-horizontal"
        >
          <div class="disco-chip" *ngIf="item?.tag">
            <ion-chip
              class="tertiary-chip ion-no-padding ion-no-margin fs-2 font500"
            >
              {{ item?.tag }}
            </ion-chip>
          </div>
          <ion-card-title
            class="fs-3 font600 text-wrap ion-no-margin l-height21 card-primary-text-color"
          >
            {{ item?.title }}</ion-card-title
          >
          <p
            class="fs-2 ion-no-margin font500 location line-1-clip card-secondary-text-color"
            *ngIf="type === 'dutyfree'"
          >
            {{
              item?.locationName || "retail_list_card.multiple_locations"
                | translate
            }}
          </p>
          <p
            class="fs-2 ion-no-margin font500 location l-height17 line-1-clip card-secondary-text-color"
            *ngIf="type === 'lounges'"
          >
            {{
              selectedLocation || "retail_list_card.multiple_locations"
                | translate
            }}
          </p>
          <p
            class="fs-2 ion-no-margin font500 l-height21 card-secondary-text-color"
            *ngIf="type === 'dutyfree'"
          >
            {{ item?.operatingHours }}
          </p>
          <p
            class="fs-2 ion-no-margin font500 card-secondary-text-color line-1-clip"
            *ngIf="
              type === 'lounges' &&
              selectedLocation &&
              item?.selectedLocation?.locationInfo?.operatingHours
            "
          ></p
        ></ion-card-header>

        <ion-card-content
          class="ion-no-padding ion-padding-horizontal"
          *ngIf="item?.origPrice || item?.finalPrice"
        >
          <ion-label>
            <p
              class="strike-price-color mar0 fs-2 font500  line-1-clip"
              *ngIf="item?.origPrice > item?.finalPrice"
            >
              {{ item?.origPrice | currency : currencyCode }}
            </p>
            <p class="primary-price-color mar0 fs-3 font700 ion-no-margin line-1-clip">
              {{ item?.finalPrice | currency : currencyCode }}
            </p>
          </ion-label>
        </ion-card-content>
        <ion-button
          class="secondary-btn fs-3 font500 select-button ion-padding-horizontal marb10"
          (click)="navigateFunction(item)"
          *ngIf="type === 'dutyfree'"
          >{{ "retail_list_card.select" | translate }}</ion-button
        >
        <ion-button
          class="secondary-btn fs-3 font500 select-button ion-padding-horizontal marb10"
          (click)="navigateFunction(item)"
          *ngIf="type === 'lounges'"
          >{{ "retail_list_card.book_now_btn" | translate }}</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
